import { Login as LoginComponent } from './LoginComponent'
import { useAuthenticationState } from '../../../store/useAuthenticationState';
import React from 'react';
import { createPhpSession } from './createSession';
import { ComplianceStatus } from './ComplianceStatus';
import { ComplianceItem } from '@/components/ui/TrainingListControl';
import { hasBlockingComplianceItems } from './complianceGate';

export const Login = () => {
  const { setAuthenticationStateJWT, setAuthenticationStateLogin } = useAuthenticationState();
  const [showComplianceGate, setShowComplianceGate] = React.useState(false);
  const [redirectTarget, setRedirectTarget] = React.useState('/menu.php');
  const [loginCompliance, setLoginCompliance] = React.useState<ComplianceItem[] | null>(null);

  const resolveDashboardDestination = (sessionOk: boolean, dashboardSetting?: string) => {
    if (!sessionOk) {
      return '/dashboard';
    }
    const normalizedSetting = `${dashboardSetting || ''}`.trim().toUpperCase();
    if (normalizedSetting === 'DD2') {
      return '/dashboard';
    }
    return '/menu.php';
  };

  React.useEffect(() => {
    setAuthenticationStateJWT('');
  }, [setAuthenticationStateJWT]);

  const onSuccess = async (authenticationState: string, complianceItems?: ComplianceItem[], authUser?: any) => {
    console.log('authenticationState', authenticationState);
    if (!authenticationState) {
      window.location.href = '/login';
      //navigate('/dashboard');
      return;
    }

    setAuthenticationStateLogin(authenticationState);
    if (Array.isArray(complianceItems)) {
      setLoginCompliance(complianceItems);
    }
    if (hasBlockingComplianceItems(complianceItems || [])) {
      setShowComplianceGate(true);
      return;
    }
    const sessionOk = await createPhpSession(authenticationState);
    const destination = resolveDashboardDestination(sessionOk, authUser?.settings?.dashboard);
    setRedirectTarget(destination);
    setShowComplianceGate(true);
  };

  if (showComplianceGate) {
    return (
      <ComplianceStatus
        items={loginCompliance}
        onCleared={() => { window.location.href = redirectTarget; }}
      />
    );
  }

  return (
    <div className="fixed inset-0 overflow-y-auto bg-[linear-gradient(180deg,var(--neutral-gray-10)_0%,var(--neutral-gray-20)_100%)] px-4 py-8">
      <div className="flex min-h-full items-center justify-center">
        <LoginComponent onSuccess={onSuccess} />
      </div>
    </div>
  );
}
